import {DDQ_DROPDOWN_CHANGE, DDQ_SUBMIT_ANSWER} from '../../Redux.constants';
import {selectDropdownOption, submitDDQAnswer} from './helper';

export function DDQReducer(state = {}, action) {
  switch (action.type) {
    case DDQ_DROPDOWN_CHANGE:
      return selectDropdownOption(state, action.payload);
    case DDQ_SUBMIT_ANSWER:
      return submitDDQAnswer(state, action.payload);
    default:
      return state;
  }
}
